/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  ButtonGroup,
  CircularProgress,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

import EditIcon from "@mui/icons-material/Edit";
import { handleEditOpen, rowValue } from "../../../redux/Reducer/ModalSlice";
import { useDispatch, useSelector } from "react-redux";
import AddModal from "../../modal/AddModal";
import EditModal from "../../modal/EditModal";
import UserAdd from "./UserAdd";
import UserEdit from "./UserEdit";
import TableComp from "../../table-components/table/TableComp";
import Pagination from "../../table-components/pagination/Pagination";

import useFetch from "../../../hooks/useFetch";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import TableFilter from "../../table-components/filter/TableFilter";
import {
  ActiveStatus,
  InactiveStatus,
  StatusContainer,
} from "../../Dashboard/Dashboard.style";
import useProfile from "../../../hooks/useProfile";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UserTable = () => {
  const dispatch = useDispatch();

  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [userData] = useProfile();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  function handleEdit(rowData) {
    dispatch(handleEditOpen());
    dispatch(rowValue(rowData));
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Filter: false,
      },
      {
        Header: "Name",
        accessor: "full_name",
        Filter: false,
      },
      {
        Header: "User Name",
        accessor: "username",
        Filter: false,
      },
      {
        Header: "Email",
        accessor: "email_address",
        Filter: false,
      },
      {
        Header: "Role",
        accessor: "ugleve_name",
        Filter: false,
      },
      {
        Header: "Active Status",
        accessor: "active_fg",
        Filter: false,
        Cell: (e) => (
          <div
            style={{
              marginLeft: "10Px",
            }}
          >
            {e.value === "1" ? (
              <StatusContainer>
                <ActiveStatus>Active</ActiveStatus>
              </StatusContainer>
            ) : (
              <StatusContainer>
                <InactiveStatus>Inactive</InactiveStatus>
              </StatusContainer>
            )}
          </div>
        ),
      },
      {
        Header: () => <div style={{ marginLeft: "50px" }}>Action</div>,
        accessor: "col5",
        Cell: (row) => (
          <ButtonGroup
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update">
                <EditIcon
                  // fontSize="small"
                  sx={{ fontSize: 18 }}
                />
              </Tooltip>
            </IconButton>
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const [user, isLoading, , refetch] = useFetch(
    `${process.env.REACT_APP_API_URL}/api/userList/${userData?.id}`
  );

  const add = useSelector((state) => state.Modal.add);
  const edit = useSelector((state) => state.Modal.edit);

  useEffect(() => {
    if (!add) {
      refetch();
    }
  }, [add]);

  useEffect(() => {
    if (!edit) {
      refetch();
    }
  }, [edit]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: user },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;

  return (
    <>
      <div>
        <TableFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          ButtonName="Add User"
        />
      </div>
      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "280px",
            }}
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>

      <AddModal ModalWidth="sm" ModalTitle="Add User Information">
        <UserAdd setOpen={setOpen} setMessage={setMessage} setType={setType} />
      </AddModal>
      <EditModal ModalWidth="sm" ModalTitle="Edit User Information">
        <UserEdit setOpen={setOpen} setMessage={setMessage} setType={setType} />
      </EditModal>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={type}>{message}</Alert>
      </Snackbar>
    </>
  );
};

export default UserTable;
